import contentService from '@/services/contentService';
import type {ImageModel} from '@/types/content';
import arrayUtils from '@/utils/arrayUtils';

export type GroupedMedia = {
    key: string | number;
    item: ImageModel[];
};

export const getGroupedImageMedia = (imageMedia: ImageModel[]) => {
    const mappedOtherMedia = imageMedia.map((x) => ({...x, width: x.viewport?.width}));

    const groupedObject = arrayUtils.groupBy(mappedOtherMedia, 'width');

    return arrayUtils.objectToArray(groupedObject);
};

export const isDefaultMedia = (item: GroupedMedia) => {
    return item.key === 0 || item.key === '0';
};

export const getImageMedia = (media: ImageModel[]) => {
    if (!media?.length) return '';

    return media
        .map((image) => {
            const {path, ppi} = image;
            const srcPath = contentService.getContentPath(path);

            return `${srcPath} ${ppi ?? 1}x`;
        })
        .join(', ');
};
